import React, { useEffect, useState, useRef } from 'react';

import expensesService from '../../services/expenses';
import suppliersService from '../../services/suppliers';
import companiesService from '../../services/companies';
import constructionsService from '../../services/constructions';
import appropriationsService from '../../services/appropriation';
import paymentBanksService from '../../services/paymentBank';

import Utils from '../../components/Utils/Utils';

import FilterBar from '../../components/FilterBar';
import DatePagination from '../../components/DatePagination';
import ScrollableTable from '../../components/DataGrid/DataGrid';
import TableHeaders from '../../views/Conciliation/table-headers';
import MaskInput from '../../components/Layout/MaskInput';

import invoiceIcon from '../../assets/invoice-icon.png';
import printIcon from '../../assets/print-icon.svg';
import xmlIcon from '../../assets/xmlb.png';
import loaderIcon from '../../assets/loader.svg';
import './Conciliation.scss';

import ModalPDF from '../../components/ModalPDF';
import ModalAttach from '../../components/ModalAttach';
import ModalOrganizePDF from '../../components/ModalOrganizePDF';
import { size } from 'lodash';

import JSZip from "jszip";
import { saveAs } from "file-saver";

function Conciliation() {
  useEffect(() => {
    if (!sessionStorage.getItem('hasReloaded')) {
      sessionStorage.setItem('hasReloaded', 'true');
      window.location.reload();
    }
  }, []);

  const [fields, setFields] = useState({});
  const [expenses, setExpenses] = useState([]);
  const pendingUpdates = useRef(new Set()); // Track pending updates
  const [rowLoading, setRowLoading] = useState({});

  const [suppliers, setSuppliers] = useState([]);
  const [constructions, setConstructions] = useState([]);
  const [appropriations, setAppropriations] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [paymentApproachList, setPaymentApproachList] = useState([]);
  const [selectedDate, setSelectedDate] = useState({});
  const [getRequestComp, setGetRequestComp] = useState(0);

  const [loader, setLoader] = useState(false);
  const [modalPDF, setModalPDF] = useState({status: false, url: ''});
  const [modalAttach, setModalAttach] = useState({status: false, code: ''});
  const [modalOrganize, setModalOrganize] = useState({ status: false, url: '', expenseID: null });
  const [openPdfMenu, setOpenPdfMenu] = useState(null);
  
  const [typeSearchString, setTypeSearchString] = useState('');
  
  //const [paymentApproachList, setPaymentApproachList] = useState([{ id: 1, name: 'Cheque' }, { id: 2, name: 'Dinheiro' }, { id: 3, name: 'Internet' }, { id: 4, name: 'Débito C.C.' } ]);
  //const [appropriationList, setAppropriation] = useState([{ id: 1, name: 'Fundação' }, { id: 2, name: 'Alvenaria' }, { id: 3, name: 'Esquadrias' }, { id: 3, name: 'Pintura' }, { id: 3, name: 'Telhado' }]);

  const [orderBy, setOrderBy] = useState([['expenseDate', 'ASC']]);
  const [deleteModal, setDeleteModal] = useState({ status: false, deleteExpID: null, paid: false });
  const [repLancModal, setRepLancModal] = useState({ status: false, repExpID: null });
  const [parcLancModal, setParcLancModal] = useState({ status: false, repExpID: null });
  const [repLancQtd, setRepLancQtd] = useState(1);
  const [parcLancQtd, setParcLancQtd] = useState(2);
  const [highlightedRow, setHighlightedRow] = useState(null);

  const zipRef = useRef(new JSZip());

  // Função para adicionar arquivo ao ZIP
  const addFileToZip = (key, xmlContent) => {
    const filename = `${key}.xml`;
    zipRef.current.file(filename, xmlContent);
  };

  // Função para baixar o ZIP
  const handleDownloadZip = async () => {
    const zipBlob = await zipRef.current.generateAsync({ type: "blob" });
    saveAs(zipBlob, "xmls.zip");
  };

  const dynamicFieldsCheck = (expense) => {
    zipRef.current = new JSZip();
    const dynamicFields = {};
    expense.forEach((expenseItem) => {
      dynamicFields[`expenseID${expenseItem.expenseID}`] = {
        expenseDate: { value: expenseItem.expenseDate.replace('--', '-0'), valid: true, validationMessage: '' },
        pdfPath: { value: expenseItem.pdfPath, valid: true, validationMessage: '' },
        billPath: { value: '-', valid: true, validationMessage: '' },
        
        companyID: { value: expenseItem.companyID, valid: true, validationMessage: '' },
        constructionID: { value: expenseItem.constructionID, valid: true, validationMessage: '' },
        supplierID: { value: expenseItem.supplierID, valid: true, validationMessage: '' },
        appropriationID: { value: expenseItem.appropriationID, valid: true, validationMessage: '' },

        invoiceID: { value: expenseItem.invoiceID, valid: null, validationMessage: '' },
        dueDate: { value: expenseItem.dueDate, valid: null, validationMessage: '' },
        amount: { value: expenseItem.amount, valid: null, validationMessage: '' },
        comments: { value: expenseItem.comments, valid: true, validationMessage: '' },
        installment: { value: expenseItem.installment, valid: null, validationMessage: '' },
        buyer: { value: !expenseItem.user ? 'Importada' : expenseItem.user.name, valid: true, validationMessage: '' },
        userID: { value: expenseItem.userID, valid: null, validationMessage: '' },
        retention: { value: expenseItem.retention, valid: true, validationMessage: '' },
        paymentDate: { value: expenseItem.paymentDate, valid: true, validationMessage: '' },
        appropriation: { value: '', valid: true, validationMessage: '' },
        payment_approach: { value: expenseItem.payment_approach, valid: true, validationMessage: '' },
        paid: { value: expenseItem.paid, valid: false, validationMessage: '' },
        conciliation: { value: expenseItem.conciliation, valid: true, validationMessage: '' },
        accounting: { value: expenseItem.accounting, valid: true, validationMessage: '' },
        expenseOrigID: { value: expenseItem.expenseOrigID, valid: null, validationMessage: '' },
      };
      if  (expenseItem.chaveNFe != null)
        addFileToZip(expenseItem.chaveNFe, expenseItem.nfXmlCC || expenseItem.nfXml);
    });

    // Update initialFields with dynamicFields
    setFields((prevFields) => ({
      ...prevFields,
      ...dynamicFields,
    }));
  }

  const permission = parseInt(sessionStorage.getItem('MonteVerdePermission'), 10);

  const handleDeleteClick = (expenseID, paid) => {
    setHighlightedRow(expenseID);
    setDeleteModal({ status: true, deleteExpID: expenseID, paid: paid });
  };
  
  const handleRepLancModal = (expenseID) => {
    setRepLancModal({ status: true, repExpID: expenseID });
  };

  const handleParcLancModal = (expenseID) => {
    setParcLancModal({ status: true, repExpID: expenseID });
  };

  const handleCloseModal = (e) => {
    setModalPDF({ status: false, url: '' });
    setModalAttach({ status: false, code: 0 });
  }

  function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
  }

  useEffect(() => {
    const getSuppliers = async () => {
      try {
        const supplier = await suppliersService.getAll();
        setSuppliers(supplier.data);
      } catch (error) {
        console.error('Error fetching expenses:', error);
      }
    };

    const getCompanies = async () => {
      try {
        const company = await companiesService.getAll();
        setCompanies(company.data);
      } catch (error) {
        console.error('Error fetching expenses:', error);
      }
    };

    const getConstructions = async () => {
      try {
        const construction = await constructionsService.getAll();
        setConstructions(construction.data);
      } catch (error) {
        console.error('Error fetching expenses:', error);
      }
    };

    const getAppropriations = async () => {
      try {
        const appropriationData = await appropriationsService.getAll();
        setAppropriations(appropriationData.data);
      } catch (error) {
        console.error('Error fetching expenses:', error);
      }
    };
    
    const getPaymentBanks = async () => {
      try {
        const paymentData = await paymentBanksService.getAll();
        setPaymentApproachList(paymentData.data);
      } catch (error) {
        console.error('Error fetching paymentbank:', error);
      }
    };

    getAppropriations();
    getSuppliers();
    getCompanies();
    getConstructions();
    getPaymentBanks();
  }, []);

  useEffect(() => {
    const timer = setTimeout(async () => {
      if (pendingUpdates.current.size === 0) return;

      // Snapshot e limpa antes do trabalho assíncrono: qualquer nova alteração
      // feita durante os awaits será adicionada ao set limpo e processada
      // pelo próximo timer, sem ser perdida.
      const toProcess = [...pendingUpdates.current];
      pendingUpdates.current.clear();

      for (const expenseID of toProcess) {
        const updatedFields = fields[`expenseID${expenseID}`];

        if (updatedFields) {
          const values = {
            expenseID,
            ...Object.fromEntries(
              Object.entries(updatedFields).map(([key, value]) => [key, value.value])
            ),
          };

          try {
            setRowLoading((prev) => ({ ...prev, [expenseID]: true }));
            await expensesService.updateExpense(expenseID, values);
            setRowLoading((prev) => ({ ...prev, [expenseID]: false }));
          } catch (error) {
            console.error('Error updating expense:', error);
            setRowLoading((prev) => ({ ...prev, [expenseID]: false }));
          }
        }
      }

      setLoader(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, [fields]);  

  const handleFilterExpenses = (filteredExpenses) => {
    setExpenses([]);
    setLoader(true);
    setTimeout(() => {
      dynamicFieldsCheck(filteredExpenses);
      setExpenses(filteredExpenses);
      setLoader(false);
    }, 0)
  };

  useEffect(() => {
    return () => {
      pendingUpdates.current.clear();
    };
  }, []);

  useEffect(() => {
    if (!openPdfMenu) return;
    const close = () => setOpenPdfMenu(null);
    document.addEventListener('click', close);
    return () => document.removeEventListener('click', close);
  }, [openPdfMenu]);

  /* Handles */
    const handleSelectChange = async (e, expenseID, param) => {
      const newValue = e.target.value;

      if(newValue) {
        setFields((prevFields) => ({
          ...prevFields,
          [`expenseID${expenseID}`]: {
            ...prevFields[`expenseID${expenseID}`],
            [param]: {
              ...prevFields[`expenseID${expenseID}`]?.[param],
              value: newValue,
            },
          },
        }));

        pendingUpdates.current.add(expenseID);
      }
    };

    const handleCompetenceChange = async (e, expenseID) => {
      const newMonth = e.target.value.split('/');
      const expenseDate = fields[`expenseID${expenseID}`]['expenseDate'].value;
      const updatedDate = `${newMonth[1]}-${newMonth[0]}-${expenseDate.substr(expenseDate.length - 2, expenseDate.length)}`;

      setFields((prevFields) => ({
        ...prevFields,
        [`expenseID${expenseID}`]: {
          ...prevFields[`expenseID${expenseID}`],
          ['expenseDate']: {
            ...prevFields[`expenseID${expenseID}`]?.['expenseDate'],
            value: updatedDate,
          },
        },
      }));
      setLoader(true);
      setTimeout(() => {
        setGetRequestComp(getRandomInt(1, 1000));
      }, 500)
      pendingUpdates.current.add(expenseID);
      // setTimeout(() => {
      //   window.location.reload();
      // }, 1000);
      // processTrialMtDB(expenseID, updatedDate);
    };

    
 
    const handleInputChange = (e, expenseID) => {
      let name = '';
      let value = '';
      if (e.type !== 'change') {
        name = e.type;
        value = e.formattedValue;
      } else {
        value = e.target.value;
        name = e.target.name;
      }

      if (name === 'amount') {
        value = parseFloat(value.replace('R$', '').replace('.', '').replace(',', '.').trim());
      }

      setFields((prevFields) => ({
        ...prevFields,
        [`expenseID${expenseID}`]: {
          ...prevFields[`expenseID${expenseID}`],
          [name]: {
            ...prevFields[`expenseID${expenseID}`]?.[name],
            value: value,
          },
        },
      }));

      pendingUpdates.current.add(expenseID);
    };

    const handleCheckboxChange = (e, expenseID, param) => {
      const brazilianDate = new Date(new Date().toLocaleString("en-US", { timeZone: "America/Sao_Paulo" }));
      const year = brazilianDate.getFullYear();
      const month = String(brazilianDate.getMonth() + 1).padStart(2, '0');
      const day = String(brazilianDate.getDate()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;

      
      //const resultado = expenses.find(item => item.expenseID === expenseID);
      //console.log(resultado);

      const { checked } = e.target;

      setFields((prevFields) => ({
        ...prevFields,
        [`expenseID${expenseID}`]: {
          ...prevFields[`expenseID${expenseID}`],
          [param]: {
            ...prevFields[`expenseID${expenseID}`]?.[param],
            value: checked,
          },
          ...(param === 'conciliation' && checked ?  {
                'paymentDate': {
                  value: formattedDate
                }
              } : param === 'conciliation' && !checked ? {
                'paymentDate': {
                  value: null
                }
              } : {}),
          ...(param === 'paid' && checked ?  {
                'userID': {
                  value: sessionStorage.getItem('MonteVerdeUserId')
                },
                'buyer': {
                  value: sessionStorage.getItem('MonteVerdeUsername')
                }
              } : param === 'paid' && !checked ? {
                'paymentDate': {
                  value: null
                },
                'conciliation': {
                  value: false
                },
                'userID': {
                  value: null
                }
              } : {})
        },
      }));
  
      pendingUpdates.current.add(expenseID);
    };

    const handleUrlUpload = (url, expenseID) => {
      setFields((prevFields) => ({
        ...prevFields,
        [`expenseID${expenseID}`]: {
          ...prevFields[`expenseID${expenseID}`],
          pdfPath: { value: url },
        },
      }));
  
      pendingUpdates.current.add(expenseID);
    };
  /* // Handles */

  const renderSelectOptions = (data, keyField, displayField, selectedValue) => (
    <>
      <option key={0} value={0} className='no-print'>Selecione</option>
      {data.map((item, index) => (
        <option key={index} value={item[keyField]} defaultValue={item[keyField] === selectedValue}>
          {item[displayField]}
        </option>
      ))}
    </>
  );

  const handleDateChange = (date) => {
    if(typeof date !== 'object' && date !== null) {
      setSelectedDate(date);
      setTypeSearchString(date);
    }
  };

  function generateMonthOptions(expenseID) {
    const currentDate = fields[`expenseID${expenseID}`]?.['expenseDate'].value ? new Date(fields[`expenseID${expenseID}`]?.['expenseDate'].value) : new Date();
    const options = Array.from({ length: 3 }, (_, index) => {
      const date = new Date(currentDate.getFullYear(), currentDate.getMonth() + index - 1);
      const formattedOption = `${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
      return formattedOption;
    });
  
    return options;
  }
  let competencePrint=generateMonthOptions('expense.expenseID')

  const handlePrintClick = () => {
    window.print();
  };

  const handleXMLClick = () => {
    
  };

  const getAccountingValue = (expense, fields) => {
    const local = fields[`expenseID${expense.expenseID}`]?.accounting?.value;
    return (local ?? expense.accounting ?? '').toString(); // SEM constructionID
  };

  let totalExpenses = 0;
  let rows = [];
  if(permission !== 4) {
    rows = expenses.map((expense, index) => {
      totalExpenses = totalExpenses + expense.amount;
      function formattedDate(dateStr) {
        if (!dateStr) return '';
        const parts = String(dateStr).split('T')[0].split('-');
        if (parts.length !== 3) return '';
        return `${parts[2]}/${parts[1]}/${parts[0]}`;
      }


      return {
        expenseID: expense.expenseID,
        companyName: 
        rowLoading[expense.expenseID] ? (
            <div className="row-loader">
                <img src={loaderIcon} alt="Loading..." width={20} height={20} />
            </div>
        ) : (
            <div className='wrapper-select no-print'>
                <select
                    name='company'
                    defaultValue={fields[`expenseID${expense.expenseID}`]?.companyID.value}
                    onChange={(e) => handleSelectChange(e, expense.expenseID, 'companyID')}
                    disabled={(permission === 2) || (permission === 3 && fields[`expenseID${expense.expenseID}`]?.paid.value)}
                >
                    {renderSelectOptions(companies, 'companyID', 'name')}
                </select>
            </div>
        ),
        constrution: 
        rowLoading[expense.expenseID] ? (
            <div className="row-loader">
                <img src={loaderIcon} alt="Loading..." width={20} height={20} />
            </div>
        ) : (
          <div>
            <div className='wrapper-select'>
                <select
                    name='construction'
                    defaultValue={fields[`expenseID${expense.expenseID}`]?.constructionID.value}
                    onChange={(e) => handleSelectChange(e, expense.expenseID, 'constructionID')}
                    disabled={(permission === 2) || (permission === 3 && fields[`expenseID${expense.expenseID}`]?.paid.value)}
                >
                    {renderSelectOptions(constructions, 'constructionID', 'name')}
                </select>
            </div>
            <span className='print'>
                {constructions.find(c => c.constructionID === fields[`expenseID${expense.expenseID}`]?.constructionID.value)?.name || ""}
            </span>
          </div>
        ),
        supplier: 
        rowLoading[expense.expenseID] ? (
            <div className="row-loader">
                <img src={loaderIcon} alt="Loading..." width={20} height={20} />
            </div>
        ) : (
          <div>
            <div className='wrapper-select'>
              <select
                  name='supplier'
                  defaultValue={fields[`expenseID${expense.expenseID}`]?.supplierID.value}
                  onChange={(e) => handleSelectChange(e, expense.expenseID, 'supplierID')}
                  disabled={(permission === 2) || (permission === 3 && fields[`expenseID${expense.expenseID}`]?.paid.value)}
              >
                  {renderSelectOptions(suppliers, 'supplierID', 'name')}
              </select>
            </div>
            <span className='print'>
                {suppliers.find(c => c.supplierID === fields[`expenseID${expense.expenseID}`]?.supplierID.value)?.name || ""}
            </span>
          </div>
        ),
        invoiceID: 
        rowLoading[expense.expenseID] ? (
            <div className="row-loader">
                <img src={loaderIcon} alt="Loading..." width={20} height={20} />
            </div>
        ) : (
            <>
                <input
                    type="text"
                    name="invoiceID"
                    onChange={(e) => handleInputChange(e, expense.expenseID)}
                    defaultValue={fields[`expenseID${expense.expenseID}`]?.invoiceID.value}
                    className='no-print'
                    disabled={(permission === 2) || (permission === 3 && fields[`expenseID${expense.expenseID}`]?.paid.value)}
                />
                <span className='print'>
                    {fields[`expenseID${expense.expenseID}`]?.invoiceID.value}
                </span>
            </>
        ),
        retention: 
        rowLoading[expense.expenseID] ? (
            <div className="row-loader">
                <img src={loaderIcon} alt="Loading..." width={20} height={20} />
            </div>
        ) : (
            <input
                type='checkbox'
                name={`retention-${expense.expenseID}`}
                checked={fields[`expenseID${expense.expenseID}`]?.retention.value || false}
                onChange={(e) => handleCheckboxChange(e, expense.expenseID, 'retention')}
                disabled={(permission === 2) || (permission === 3 && fields[`expenseID${expense.expenseID}`]?.paid.value)}
            />
        ),
        dueDate: 
        rowLoading[expense.expenseID] ? (
            <div className="row-loader">
                <img src={loaderIcon} alt="Loading..." width={20} height={20} />
            </div>
        ) : (
            <>
                <input
                    type='date'
                    name='dueDate'
                    onChange={(e) => handleInputChange(e, expense.expenseID)}
                    value={fields[`expenseID${expense.expenseID}`]?.dueDate.value}
                    disabled={(permission === 2) || (permission === 3 && fields[`expenseID${expense.expenseID}`]?.paid.value)}
                    className='no-print'
                />
                <span className='print'>
                    {formattedDate(fields[`expenseID${expense.expenseID}`]?.dueDate.value)}
                </span>
            </>
        ),
        payment: 
        rowLoading[expense.expenseID] ? (
            <div className="row-loader">
                <img src={loaderIcon} alt="Loading..." width={20} height={20} />
            </div>
        ) : (
            <>
                <input
                    type='date'
                    name='paymentDate'
                    onChange={(e) => handleInputChange(e, expense.expenseID)}
                    value={fields[`expenseID${expense.expenseID}`]?.paymentDate.value}
                    disabled={(permission === 2) || (permission === 3 && fields[`expenseID${expense.expenseID}`]?.paid.value)}
                    className='no-print'
                />
                <span className='print'>
                    {formattedDate(fields[`expenseID${expense.expenseID}`]?.paymentDate.value)}
                </span>
            </>
        ),
        payment_approach: 
        rowLoading[expense.expenseID] ? (
            <div className="row-loader">
                <img src={loaderIcon} alt="Loading..." width={20} height={20} />
            </div>
        ) : (
          <div>
            <div className='wrapper-select'>
                <select
                    name='payment_approach'
                    defaultValue={fields[`expenseID${expense.expenseID}`]?.payment_approach.value}
                    onChange={(e) => handleSelectChange(e, expense.expenseID, 'payment_approach')}
                    disabled={(permission === 2) || (permission === 3 && fields[`expenseID${expense.expenseID}`]?.paid.value)}
                >
                    {renderSelectOptions(paymentApproachList, 'paymentBankID', 'name')}
                </select>
            </div>
            <span className='print'>
                {paymentApproachList.find(c => c.paymentBankID == fields[`expenseID${expense.expenseID}`]?.payment_approach.value)?.name || ""}
            </span>
          </div>
        ),
        amount: 
        rowLoading[expense.expenseID] ? (
            <div className="row-loader">
              <img src={loaderIcon} alt="Loading..." width={20} height={20} />
            </div>
        ) : (
          (permission <= 3 && !fields[`expenseID${expense.expenseID}`]?.paid.value) || (permission === 1 && fields[`expenseID${expense.expenseID}`]?.paid.value) ? (
            <MaskInput
              type="amount"
              defaultValue={Utils.currencyFormat(fields[`expenseID${expense.expenseID}`]?.amount.value)}
              placeholder={"R$ 0,00"}
              onValueChange={(e) => handleInputChange(e, expense.expenseID)}
              tabIndex={8}
            />
          ) : (
            <input
              type='text'
              defaultValue={Utils.currencyFormat(fields[`expenseID${expense.expenseID}`]?.amount.value)}
              disabled={true}
              style={{ textAlign: 'right' }}
            />
          )
        ),
        comments: 
        rowLoading[expense.expenseID] ? (
            <div className="row-loader">
                <img src={loaderIcon} alt="Loading..." width={20} height={20} />
            </div>
        ) : (
          <div>
            <input
                type='text'
                name='comments'
                onChange={(e) => handleInputChange(e, expense.expenseID)}
                defaultValue={fields[`expenseID${expense.expenseID}`]?.comments.value}
                className='no-print'
                disabled={(permission === 2) || (permission === 3 && fields[`expenseID${expense.expenseID}`]?.paid.value)}
            />
            <span className='print'>
                {fields[`expenseID${expense.expenseID}`]?.comments.value || ""}
            </span>
          </div>
        ),
        invoice_bill:
        rowLoading[expense.expenseID] ? (
            <div className="row-loader">
                <img src={loaderIcon} alt="Loading..." width={20} height={20} />
            </div>
        ) : (() => {
          const pdfVal = fields[`expenseID${expense.expenseID}`]?.pdfPath?.value || '';
          if (!pdfVal.includes('.pdf')) return null;
          const isMenuOpen = openPdfMenu === expense.expenseID;
          return (
            <div className="pdf-menu-wrapper" onClick={e => e.stopPropagation()}>
              <button
                className="pdf-menu-trigger"
                onClick={() => setOpenPdfMenu(isMenuOpen ? null : expense.expenseID)}
              >
                <img style={{ width: '35px' }} src={invoiceIcon} alt="Documento PDF" />
              </button>
              {isMenuOpen && (
                <div className="pdf-menu-dropdown">
                  <button onClick={() => { setOpenPdfMenu(null); setModalPDF({ status: true, url: pdfVal }); }}>
                    Ver
                  </button>
                  <button onClick={() => { setOpenPdfMenu(null); setModalOrganize({ status: true, url: pdfVal, expenseID: expense.expenseID }); }}>
                    Organizar
                  </button>
                </div>
              )}
            </div>
          );
        })(),
        attach: 
        rowLoading[expense.expenseID] ? (
            <div className="row-loader">
                <img src={loaderIcon} alt="Loading..." width={20} height={20} />
            </div>
        ) : (
          (permission === 1 || (permission === 3)) && 
          (
            <button
                className="btn-add-more"
                onClick={() => setModalAttach({
                    expenseID: expense.expenseID,
                    status: true,
                    //mtId: constructions.find(item => item.constructionID === fields[`expenseID${expense.expenseID}`]?.constructionID.value).mtId,
                    dueDate: fields[`expenseID${expense.expenseID}`]?.dueDate.value,
                    companies: companies,
                    companyID: fields[`expenseID${expense.expenseID}`]?.companyID.value,
                    url: fields[`expenseID${expense.expenseID}`]?.pdfPath.value
                })}
                disabled={(permission === 2) && fields[`expenseID${expense.expenseID}`]?.paid.value}
            >
                +
            </button>
          )
        ),
        buyer: rowLoading[expense.expenseID] ? (
            <div className="row-loader">
                <img src={loaderIcon} alt="Loading..." width={20} height={20} />
            </div>
        ) : (
            fields[`expenseID${expense.expenseID}`]?.buyer.value
        ),
        paid: 
        rowLoading[expense.expenseID] ? (
            <div className="row-loader">
                <img src={loaderIcon} alt="Loading..." width={20} height={20} />
            </div>
        ) : (
            <input
                type='checkbox'
                name={`paid-${expense.expenseID}`}
                checked={fields[`expenseID${expense.expenseID}`]?.paid.value || false}
                onChange={(e) => handleCheckboxChange(e, expense.expenseID, 'paid')}
                disabled={(permission === 2) || (permission === 3 && fields[`expenseID${expense.expenseID}`]?.paid.value)}
            />
        ),
        conciliation: 
        rowLoading[expense.expenseID] ? (
            <div className="row-loader">
                <img src={loaderIcon} alt="Loading..." width={20} height={20} />
            </div>
        ) : (
            fields[`expenseID${expense.expenseID}`]?.paid?.value ? (
                <input
                    type='checkbox'
                    name={`conciliation-${expense.expenseID}`}
                    checked={fields[`expenseID${expense.expenseID}`]?.conciliation.value || false}
                    onChange={(e) => handleCheckboxChange(e, expense.expenseID, 'conciliation')}
                    disabled={(permission === 2) || (permission === 3 && fields[`expenseID${expense.expenseID}`]?.paid.value)}
                />
            ) : null
        ),
        appropriation: 
        rowLoading[expense.expenseID] ? (
            <div className="row-loader">
                <img src={loaderIcon} alt="Loading..." width={20} height={20} />
            </div>
        ) : (
            <div className='wrapper-select'>
                <select
                    name='appropriation'
                    defaultValue={fields[`expenseID${expense.expenseID}`]?.appropriationID.value}
                    onChange={(e) => handleSelectChange(e, expense.expenseID, 'appropriationID')}
                    disabled={permission === 3}
                >
                    {renderSelectOptions(appropriations, 'appropriationID', 'name')}
                </select>
            </div>
        ),
        accounting: 
        rowLoading[expense.expenseID] ? (
            <div className="row-loader">
                <img src={loaderIcon} alt="Loading..." width={20} height={20} />
            </div>
        ) : (
          <div>
            <div className='wrapper-select'>
                <select
                  name="accounting"
                  value={getAccountingValue(expense, fields)}                 // << controlado!
                  onChange={(e) => handleSelectChange(e, expense.expenseID, 'accounting')}
                  disabled={
                    (permission === 2) ||
                    (permission === 3 && fields[`expenseID${expense.expenseID}`]?.paid?.value)
                  }
                >
                  <option value="">Selecione</option>
                  <option value="Materiais">Materiais</option>
                  <option value="Projetos_Custos_Tecnicos">Projetos/Custos Técnicos</option>
                  <option value="Mao_de_Obra_Terceiros">Mão de Obra Terceiros</option>
                  <option value="Outros_Custos">Outros Custos</option>
                  <option value="Decorado">Decorado</option>
                  <option value="Geral">Geral</option>
                  <option value="Energia_Eletrica">Energia Elétrica</option>
                  <option value="Agua">Água</option>
                  <option value="Impostos">Impostos</option>
                  <option value="IPTU">IPTU</option>
                  <option value="Publicidade">Publicidade</option>
                </select>
            </div>
            <span className='print'>
                {fields[`expenseID${expense.expenseID}`]?.accounting.value || ""}
            </span>
          </div>
        ),
        competence: 
        rowLoading[expense.expenseID] ? (
            <div className="row-loader">
                <img src={loaderIcon} alt="Loading..." width={20} height={20} />
            </div>
        ) : /*(
            <div className='wrapper-select'>
                <span className='print'>
                    {competencePrint[1]}
                </span>
                <select
                    name='competence'
                    onChange={(e) => handleCompetenceChange(e, expense.expenseID, 'competence')}
                    disabled={(permission === 2) || (permission === 3 && fields[`expenseID${expense.expenseID}`]?.paid.value)}
                    className='no-print'
                >
                    {generateMonthOptions(expense.expenseID).map((option, index) => (
                        <option 
                            selected={index === 1} 
                            key={index}
                            className='no-print'
                        >
                            {option}
                        </option>
                    ))}
                </select>
            </div>
        ),*/
        (
          <>
              <input
                  type='date'
                  name='expenseDate'
                  onChange={(e) => handleInputChange(e, expense.expenseID)}
                  value={fields[`expenseID${expense.expenseID}`]?.expenseDate.value}
                  className='no-print'
              />
              <span className='print'>
                  {formattedDate(fields[`expenseID${expense.expenseID}`]?.expenseDate.value)}
              </span>
          </>
        ),
        actions: 
        rowLoading[expense.expenseID] ? (
          <div className="row-loader">
            <img src={loaderIcon} alt="Loading..." width={20} height={20} />
          </div>
        ) : 
        <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
          {((permission === 1 && sessionStorage.getItem('MonteVerdeEmail') == 'manuela@mverde.com.br')) && 
            (
              <button className="btn-add-more" style={{ fontSize: 10 }} onClick={(e) => handleDeleteClick(expense.expenseID, fields[`expenseID${expense.expenseID}`]?.paid.value)}>
                  X
              </button>
            )}
            {permission === 1 && (
              <button 
                  className="btn-add-more" 
                  style={{ 
                      width: "22px",  
                      height: "22px",  
                      display: "flex",  
                      alignItems: "center",  
                      justifyContent: "center",  
                      padding: "0",  
                      border: "none",  
                      cursor: "pointer",
                      fontSize: "17px" 
                  }}
                  onClick={(e) => handleRepLancModal(expense.expenseID)}
              >
                  <span style={{ display: "flex", alignItems: "center", justifyContent: "center", lineHeight: "1", margin: "-4px 0 0 1px" }}>
                      ⟳
                  </span>
              </button> )}
              {(permission === 1 && !fields[`expenseID${expense.expenseID}`]?.expenseOrigID.value) && (
              <button 
                  className="btn-add-more" 
                  style={{ 
                      width: "22px",  
                      height: "22px",  
                      display: "flex",  
                      alignItems: "center",  
                      justifyContent: "center",  
                      padding: "0",  
                      border: "none",  
                      cursor: "pointer",
                      fontSize: "17px" 
                  }}
                  onClick={(e) => handleParcLancModal(expense.expenseID)}
              >
                  <span style={{ display: "flex", alignItems: "center", justifyContent: "center", lineHeight: "1",  marginBottom: "inherit", fontWeight: "normal"}}>
                    &oslash;
                  </span>
              </button> )}
            </div>
      };
    });
  } else {
    rows = expenses.map((expense, index) => {
      totalExpenses = totalExpenses + expense.amount;
      const DueDate = expense.dueDate.split('-');
      const updatedDate = `${DueDate[1]}/${DueDate[0]}`;
      
      return {
        expenseID: expense.expenseID,
        companyName: companies.find(c => c.companyID === expense.companyID)?.name,
        supplier: suppliers.find(c => c.supplierID === expense.supplierID)?.name,
        invoiceID: fields[`expenseID${expense.expenseID}`]?.invoiceID.value || '',
        retention: fields[`expenseID${expense.expenseID}`]?.retention.value ? 'Sim' : 'Não',
        payment: expense.paymentDate && expense.paymentDate != 'null' ? new Date(expense.paymentDate).toLocaleString("pt-BR", { timeZone: "America/Sao_Paulo", day: '2-digit', month: '2-digit', year: 'numeric' }) : '-',
        amount: Utils.currencyFormat(fields[`expenseID${expense.expenseID}`]?.amount.value) || '',
        comments: fields[`expenseID${expense.expenseID}`]?.comments.value || '',
        invoice_bill: fields[`expenseID${expense.expenseID}`]?.pdfPath.value.indexOf('https') !== -1 && <button style={{ background: 'transparent', border: '0' }} onClick={() =>setModalPDF({ status: true, url: fields[`expenseID${expense.expenseID}`]?.pdfPath.value })}><img style={{ width: '35px' }} src={invoiceIcon} alt="Acessar documento." /></button>,
        paid: fields[`expenseID${expense.expenseID}`]?.paid.value ? 'Sim' : 'Não',
        accounting: constructions.find(c => c.constructionID === (expense.accounting ? parseInt(expense.accounting, 10) : parseInt(expense.constructionID, 10)))?.name || 'Não Contabilizado',
        competence: updatedDate, // Replace with appropriate string
      };
   });
  }

  const handleDeleteExpense = async (expenseID) => {
    let pdfPath = fields[`expenseID${expenseID}`]?.pdfPath.value
    if(pdfPath.indexOf('https') !== -1) {
      pdfPath = fields[`expenseID${expenseID}`]?.pdfPath.value.split('documents/')[1].split('/')[1].replace('.pdf', '')
    } else {
      pdfPath = '';
    }
    try {
      setLoader(true);
      await expensesService.deleteExpense(expenseID, pdfPath);
      setDeleteModal({ status: false, deleteExpID: null, paid: false })
      setGetRequestComp(getRandomInt(1, 1000));
      setTimeout(() => {
        setLoader(false);
      }, 500);
    } catch (error) {
      console.error('Error deleting expense:', error);
    }
  };

  const handleRepLancExpense = async (expenseID) => {
    try {
      setLoader(true);
      await expensesService.replicateExpense(expenseID, {repLancQtd:repLancQtd.toString()});
      
      setRepLancModal({ status: false, repExpID: null });
      setGetRequestComp(getRandomInt(1, 1000));
      setTimeout(() => {
        setLoader(false);
        document.getElementsByClassName('btn--primary')[0].click();
      }, 500);
    } catch (error) {
      console.error('Error replicating expense:', error);
    }
  };

  const handleParcLancExpense = async (expenseID) => {
    try {
      setLoader(true);
      await expensesService.parcellateExpense(expenseID, {parcLancQtd:parcLancQtd.toString()});
      
      setParcLancModal({ status: false, repExpID: null });
      setGetRequestComp(getRandomInt(1, 1000));
      setTimeout(() => {
        setLoader(false);
        document.getElementsByClassName('btn--primary')[0].click();
      }, 500);
    } catch (error) {
      console.error('Error parceling expense:', error);
    }
  };  

  const colSpanMapping = {
    1: { colSpanTotal: 9, colSpanEnd: 10, colSpanTotalPrint: 6 },
    2: { colSpanTotal: 8, colSpanEnd: 4, colSpanTotalPrint: 6 },
    3: { colSpanTotal: 7, colSpanEnd: 5, colSpanTotalPrint: 6 },
    4: { colSpanTotal: 6, colSpanEnd: 4, colSpanTotalPrint: 6 },
  };
  
  const { colSpanTotal, colSpanEnd, colSpanTotalPrint } = colSpanMapping[permission] || {};
  const tableFooter = (
    <>
      <tr className='tfoot'>
        <td colSpan={colSpanTotalPrint} className='print' style={{textAlign: 'right'}}><strong>Total:</strong></td>
        <td  style={{textAlign: 'right', paddingLeft: '10px'}} colSpan={1} className='print'><strong><span>{ Utils.currencyFormat(totalExpenses) }</span></strong></td>
        <td  colSpan={1} className='print'>&nbsp;</td>
        <td colSpan={colSpanTotal} style={{textAlign: 'right'}} className='no-print'><strong>Total: { Utils.currencyFormat(totalExpenses) }</strong></td>
        <td colSpan={ colSpanEnd } style={{textAlign: 'right'}} className='no-print'></td>
      </tr>
    </>
  );

  const modalDelete = (
    <>
      <div className='modal-suppliers'>
        <div className="inner-content">
            <>
              <div className="wrapper-delete">
                <h3>Você realmente deseja remover esta despesa?</h3>
                { deleteModal.paid ? (<strong style={{ display: 'block', color: 'red', margin: '10px auto' }}>Esta despesa está paga!</strong>) : '' }
                <button className={'btn--primary'} onClick={()=> {
                  handleDeleteExpense(deleteModal.deleteExpID);
                }}>Sim</button>
                <button className={'btn--primary'} onClick={()=> { 
                  setDeleteModal({ status: false, deleteExpID: null, paid: false });
                  setHighlightedRow(-1);
                }}>Não</button>
              </div>
            </>
        </div>
      </div>
    </>
  );

  const modalRepetirLancamento = (
    <>
      <div className='modal-suppliers'>
        <div className="inner-content"> 
          <button className="btn-close" style={{border: '2px solid #fff', top: '-10px', right: '-10px' }} onClick={() => {setRepLancModal({status:false, repExpID: null}); setHighlightedRow(-1);}}>X</button>
          <h3>Por quantos meses você deseja repetir esse lançamento?</h3>
          <div className='wrapper-select'>
                <select name='repLancQtd' onChange={(e) => {setRepLancQtd(e.target.value)}}>
                    <option value={1}>01</option>
                    <option value={2}>02</option>
                    <option value={3}>03</option>
                    <option value={4}>04</option>
                    <option value={5}>05</option>
                    <option value={6}>06</option>
                    <option value={7}>07</option>
                    <option value={8}>08</option>
                    <option value={9}>09</option>
                    <option value={10}>10</option>
                    <option value={11}>11</option>
                    <option value={12}>12</option>
                </select>
          </div>
          <button className={'btn--primary'} onClick={()=> { 
                  handleRepLancExpense(repLancModal.repExpID)
                }}>Repetir Lançamento</button>
        </div>
      </div>
    </>
  );

  const modalParcelarLancamento = (
    <>
      <div className='modal-suppliers'>
        <div className="inner-content"> 
          <button className="btn-close" style={{border: '2px solid #fff', top: '-10px', right: '-10px' }} onClick={() => {setParcLancModal({status:false, repExpID: null}); setHighlightedRow(-1);}}>X</button>
          <h3>Em quantas vezes você deseja parcelar este lançamento?</h3>
          <div className='wrapper-select'>
                <select name='repLancQtd' onChange={(e) => {setParcLancQtd(e.target.value)}}>
                    <option value={2}>02</option>
                    <option value={3}>03</option>
                    <option value={4}>04</option>
                    <option value={5}>05</option>
                    <option value={6}>06</option>
                    <option value={7}>07</option>
                    <option value={8}>08</option>
                    <option value={9}>09</option>
                    <option value={10}>10</option>
                    <option value={11}>11</option>
                    <option value={12}>12</option>
                </select>
          </div>
          <button className={'btn--primary'} onClick={()=> { 
                  handleParcLancExpense(parcLancModal.repExpID)
                }}>Parcelar Lançamento</button>
        </div>
      </div>
    </>
  );

  const handleOrderFields = (columnId, order) => {
    setOrderBy(prevOrderBy => {
      const isSameOrder = JSON.stringify(prevOrderBy) === JSON.stringify([[columnId, order.toUpperCase()]]);
      if (isSameOrder) {
          const newOrderBy = [columnId, prevOrderBy[1] === 'ASC' ? 'DESC' : 'ASC'];
          return newOrderBy;
      } else {
          const newOrderBy = [[columnId, order.toUpperCase()]];
          return newOrderBy;
      }
    });

    setTimeout(() => {
      setGetRequestComp(getRandomInt(1, 1000));
    }, 200);
  };
  
  return (
    <>
      <div className='conciliation-screen supplier-construction-screen'>
        <FilterBar companies={companies} orderByT={orderBy} constructions={constructions} selectedDate={selectedDate} suppliers={suppliers} appropriations={appropriations} paymentApproachList={paymentApproachList} onFilterExpenses={handleFilterExpenses} requestComp={getRequestComp} typeSearchP={typeSearchString} />
        <DatePagination onDateChange={handleDateChange} />
        {
          loader ? (
            <img src={loaderIcon} alt="Carregando..." width={100} height={100} />
          ) : (
            <>
              <a onClick={handlePrintClick}>
                <img src={printIcon} width={24} height={24} alt="Imprimir" />
              </a>

              <a onClick={handleDownloadZip} className='downloadZip'>
                <img src={xmlIcon} width={24} height={24} alt="XML Zip" />
              </a>
              <h6 className='print'>Relatório de Pagamento e Conciliação</h6>
              { deleteModal.status && modalDelete }
              { repLancModal.status && modalRepetirLancamento }
              { parcLancModal.status && modalParcelarLancamento }
              <ScrollableTable onHeaderClick={handleOrderFields} onDeleteClick={highlightedRow} headers={TableHeaders} height={'75vh'} footer={tableFooter} dataRows={rows} />
            </>
          )
        }
      </div>
      {
        modalPDF.status && <ModalPDF onCloseModal={handleCloseModal} url={modalPDF.url} />
      }
      {
        modalAttach.status && <ModalAttach onCloseModal={ handleCloseModal } onUploadSuccess={handleUrlUpload} expenseID={ modalAttach.expenseID } url={ modalAttach.url} dueDate={ modalAttach.dueDate } companies={ modalAttach.companies } companyID={ modalAttach.companyID } />
      }
      {
        modalOrganize.status && (
          <ModalOrganizePDF
            onCloseModal={() => setModalOrganize({ status: false, url: '', expenseID: null })}
            url={modalOrganize.url}
            expenseID={modalOrganize.expenseID}
            onReorganize={handleUrlUpload}
          />
        )
      }
    </>
  )
}

export default Conciliation;